export default __webpack_public_path__ + "static/media/philosophy.1e1c1932.jpg";